import { render, staticRenderFns } from "./Scantron.vue?vue&type=template&id=0a777024&scoped=true&"
import script from "./Scantron.vue?vue&type=script&lang=js&"
export * from "./Scantron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a777024",
  null
  
)

export default component.exports